import AuthFormLayout from '@layouts/form/AuthFormLayout';
import { Link, Typography } from '@mui/material';
import axios from 'axios';
import { useEffect, useRef, useState } from 'react';
import { toast } from 'react-toastify';
const backendUrl = import.meta.env.VITE_BACKEND_URL;
import { useMixpanel } from '../../context/MixpanelProvider';
import { AUTH_EVENTS } from '../../utils/eventSchema';

const VerifyEmail = ({ email }) => {
  const [timeLeft, setTimeLeft] = useState(30); // Initialize the timer with 300 seconds
  const timerRef = useRef();
  const { trackEvent } = useMixpanel();
  useEffect(() => {
    timerRef.current = setInterval(() => {
      setTimeLeft((prevTime) => prevTime - 1);
    }, 1000);

    // Clear the interval when the component unmounts
    return () => clearInterval(timerRef.current);
  }, []);

  const resendVerificationEmail = (email) => {
    return axios.post(`${backendUrl}/resend_verification_email`, { email });
  };

  const handleResend = () => {
    // Track that the user requested to resend verification email
    trackEvent('Auth', {
      ...AUTH_EVENTS.RESEND_VERIFICATION_EMAIL,
      email: email,
      verification_method: 'link',
    });

    resendVerificationEmail(email)
      .then((response) => {
        toast.success(response.data.message, {
          toastId: 'resend-verification-success',
          position: 'top-right',
          autoClose: 3000, // Auto-close after 3 seconds
        });
      })
      .catch((error) => {
        // Display an error toast if there is an error

        const errorMessage = error.response?.data?.detail || error.message || 'An error occurred';
        toast.error(errorMessage, {
          toastId: 'resend-verification-error',
          position: 'top-right',
          autoClose: 3000, // Auto-close after 3 seconds
        });
      });
  };

  return (
    <>
      <AuthFormLayout
        title="Check your Inbox ✉️"
        text={`We sent a verification link to
        ${
          email
            ? `${email.split('@')[0].slice(0, 4)}****${email.split('@')[1]}`
            : 'your email address'
        }
    
        Please check your inbox and click the link to verify your email address.`}
      >
        {timeLeft > 0 ? (
          <Typography variant="body2" color="text.secondary" textAlign={'center'}>
            Your link will expire in {timeLeft} seconds.
          </Typography>
        ) : (
          <Typography variant="body2" color="text.secondary" textAlign={'center'}>
            Didn&apos;t receive the link?{' '}
            <Link
              component="button"
              variant="body2"
              onClick={handleResend}
              style={{
                color: 'primary.main',
                fontWeight: 'bold',
                '&:hover, &:focus': {
                  textDecoration: 'none',
                  outline: '2px solid',
                  outlineColor: 'primary.main',

                  borderRadius: '2px',
                  outlineOffset: '2px',
                },
              }}
            >
              Resend it
            </Link>
          </Typography>
        )}
      </AuthFormLayout>
    </>
  );
};

export default VerifyEmail;
